
import igs21 from './igs-21'
import igs22 from './igs-22'
import igs31 from './igs-31'
import igs31se from './igs-31se'
import igs32 from './igs-32'
import igs33 from './igs-33'
import igs34 from './igs-34'

const list = [igs21, igs22, igs31, igs31se, igs32, igs33, igs34]
export default list